import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
    query subAreasActive {
        subAreasActive {
            id
            is_active
            name
            description
            status_text
            is_group_piecework
            area_id
            area {
                id
                name
                description
            }
        }
    }
`
const GET_WITH_PAGINATION = gql`
    query subAreasWithPagination ($page: Int, $perPage: Int) {
        subAreasWithPagination (page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                name
                description
                is_active
                status_text
                is_group_piecework
                area_id
                area {
                    id
                    name
                }
            }
        }
    }
`

/**
 * Mutations
 */
const CREATE = gql`
    mutation createSubArea ($input: CreateSubAreaInput!) {
        createSubArea (input: $input) {
            id
            name
            description
            area_id
            is_active
            is_group_piecework
            status_text
        }
    }
`

const UPDATE = gql`
    mutation updateSubArea ($id: ID!, $input: UpdateSubAreaInput!) {
        updateSubArea (id: $id, input: $input) {
            id
            name
            description
            area_id
            is_active
            status_text
            is_group_piecework
        }
    }
`

const CHANGE_STATUS = gql`
    mutation updateSubArea ($id: ID!, $input: UpdateSubAreaInput!) {
        updateSubArea (id: $id, input: $input) {
            id
            name
            description
            area_id
            is_active
            status_text
            is_group_piecework
        }
    }
`

const DELETE = gql`
    mutation deleteSubArea ($id: ID!) {
        deleteSubArea (id: $id) {
            id
            name
            description
            is_active
            status_text
            is_group_piecework
        }
    }
`

export {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    CHANGE_STATUS,
    DELETE
}
